import type { RoomDef, RoomKind, DoorDef, DoorKind, StairsDef, FloorId } from './types';
import type { FloorKind, WallStyle } from '@/gfx/tiles';

export function room(
  id: string, name: string, x: number, y: number, w: number, h: number,
  kind: RoomKind, floor: FloorKind, wall: WallStyle, extra: Partial<RoomDef> = {},
): RoomDef {
  return { id, name, x, y, w, h, kind, floor, wall, ...extra };
}

export function door(a: string, b: string, kind: DoorKind = 'door', extra: Partial<DoorDef> = {}): DoorDef {
  return { a, b, kind, ...extra };
}

export function stairs(
  id: string, room: string, x: number, y: number, dir: 'up' | 'down', enter: 'N' | 'S' | 'E' | 'W',
  toFloor: FloorId, to: string, extra: Partial<StairsDef> = {},
): StairsDef {
  return { id, room, x, y, dir, enter, toFloor, to, ...extra };
}
